import RouteNavigator from "@mpa/toolbox/navigation/Navigator";
import Route from "@mpa/toolbox/navigation/Route";

export const loggedInNavigator = new RouteNavigator();
export const loggedInHomeRoute = loggedInNavigator.addRoute(new Route().setPath("/"));
